import React, { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Button, Checkbox, Form, Input, Layout } from "antd";
import { login } from "./api";

const { Header, Content, Footer } = Layout;

/**
 * Full-page sign-in that mirrors the main frontend's LoginPage / LoginLayout
 * (blue header, centered 260px form with user/lock-prefixed inputs, footer).
 * The "Username" field is the account email (same as the main app).
 */
const LoginPage = ({ onSuccess }) => {
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    setLoginError(false);
    try {
      await login(values.username, values.password);
      onSuccess && onSuccess();
    } catch (e) {
      setLoginError(true);
    }
    setLoading(false);
  };

  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#1890ff",
        }}
      >
        <div className="demo-logo" style={{ color: "#fff", fontWeight: 600 }}>
          Safe Work System — Form Designer
        </div>
      </Header>
      <Content style={{ padding: "0 50px" }}>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          style={{ width: "260px", margin: "0 auto", paddingTop: "160px" }}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Please input your Username!" }]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
          </Form.Item>
          {loginError ? (
            <Form.Item>
              <Alert type="error" message="Email or Password incorrect" />
            </Form.Item>
          ) : null}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={loading}
              block
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        {new Date().getFullYear()} © Smart Solutions
      </Footer>
    </Layout>
  );
};

export default LoginPage;
